<div class="magnify-glass">
  <div (click)="makeSmaller()" class="make-smaller">
    <img src="./assets/ui/svg/grey/minus-circle.svg">
  </div>
  <div (click)="makeBigger()" class="make-bigger">
    <img src="./assets/ui/svg/grey/plus-circle.svg">
  </div>
  <div [matMenuTriggerFor]="appMenu" class="select-scale">{{ currentlySelected }}</div>
</div>

<mat-menu #appMenu="matMenu">
  <ul class="magnify-glass-popup">
    <li *ngFor="let predefine of predefinedNumbers" (click)="setCurrentValue(predefine)">{{ castNumberToLabel(predefine)}}</li>
  </ul>
</mat-menu>
